import { updateLessonItem } from 'core/crud/contents.crud';
import { useTranslate } from 'core/hooks/useTranslate';
import { parseSessionsText } from 'core/utils/sessions';
import { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';

function useSessionsTag({ sessions, onSaveSessions, lessonItemGuid }) {
  const { t } = useTranslate();
  const { addToast } = useToasts();
  const [openDialog, setOpenDialog] = useState(false);
  const [parsedSessions, setParsedSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sessions?.length > 0) {
      setParsedSessions(parseSessionsText(sessions, t));
    } else {
      setParsedSessions([]);
    }
  }, [sessions]);

  function onClickChangeSessions() {
    setOpenDialog(true);
  }
  function onCloseDialog() {
    setOpenDialog(false);
  }
  async function onSuccessDialog(value) {
    setLoading(true);
    try {
      const response = await updateLessonItem({
        guid: lessonItemGuid,
        session_ids: value.map((session) => session.id),
      });
      if (response.status === 200) {
        addToast(t('lesson:Resource updated successfully'), {
          appearance: 'success',
          autoDismiss: true,
        });
        if (onSaveSessions) {
          onSaveSessions({ session: value.map((session) => ({ session_id: session.id, session_order: session.order, session_resource_type: 'session' })) });
        }
      } else {
        addToast(t('lesson:Could not update resource'), {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      onCloseDialog();
    }
  }
  return {
    t,
    openDialog,
    parsedSessions,
    loading,
    onClickChangeSessions,
    onCloseDialog,
    onSuccessDialog,
  };
}

export default useSessionsTag;
